<template>
    <div v-if="value" class="pm-custom-dialog" style="z-index: 4;">
        <div class="pm-custom-dialog-content" style="font-size: 15px; display: flex; align-items: center; justify-content: center; padding: 0px;" :style="fullHeight ? '' : 'height: auto!important;'">
            <div style="position: relative; width: 100%; height: 100%; padding-top: 20px;">

                <slot name="default">
                </slot>

                <slot name="close-btn">
                    <div @click="close" style="position: absolute; width: 28px; height: 28px; background: #fff; line-height: 22px; text-align: center; top: 22px; right: 12px; border: 1px solid #777; border-radius: 50%;" class="main-dialog--close">
                        <span style="font-weight: 600;"><v-icon style="color: #444; font-size: 16px;">{{closeIcon}}</v-icon></span>
                    </div>
                </slot>

            </div>
        </div>
    </div>
</template>

<style>
    .pm-custom-dialog {
        position: fixed;
        z-index: 9999;
        padding: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,.5);
        backdrop-filter: blur( 4px );
        -webkit-backdrop-filter: blur( 4px );
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .pm-custom-dialog-content {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 5px 5px 15px rgba(0,0,0,.3);
        flex-grow: 0;
        max-width: 500px;
        max-height: 720px;
        width: 100%;
        height: 100%;
        text-align: center;
        display: inline-block;
        font-size: 14px;
    }


    .pm-custom-dialog-content b {
        font-weight: 600;
    }

    .pm-custom-dialog-content .retry-btn,
    .pm-custom-dialog-content .close-btn
    {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        max-width: 90vw;
        width: 250px;
        min-height: 36px;
        margin: 0 auto;
        text-decoration: none;
        border: 1px solid #2962ff;
        background-color: #fafafa;
        box-shadow: 0 0 6px rgba(0,0,0,.25), inset 2px 2px 0 #fff, inset 4px 4px 6px #d5d5d5;
        color: #2962ff;
        font-weight: 600;
        border-radius: 44px;
        padding: 8px 16px;
        text-transform: uppercase;
        margin-bottom: 40px;
        font-size: 14px;
    }

    .pm-custom-dialog-content .close-btn {
        width: 100px;
        border: none;
        border-radius: 0;
        border-bottom: 0px solid #888;
        box-shadow: none;
        background: none;
    }

    .pm-custom-dialog-content .retry-btn i {
        color: #2962ff!important;
    }
</style>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        fullHeight: {
            type: Boolean,
            default: true
        },
        onClose: {
            type: Function,
            default: () => {

            }
        },
        closeIcon: {
            type: String,
            default: "close",
        }
    },
    methods: {
        close() {
            this.value = false;
            this.$emit('input', false);
            this.$emit('close');
            this.onClose();
        },
    }
};
</script>
